export default "__VITE_ASSET__CcnlauDy__"